import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import metaAdsAPI from '../../api/metaAds';

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    deletingItem: false,
    connecting: false,
  },
};

export const getters = {
  getConnections(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.default.SET_META_ADS_UI_FLAG, { fetchingList: true });
    try {
      const response = await metaAdsAPI.get();
      commit(types.default.SET_META_ADS_CONNECTIONS, response.data);
    } catch (error) {
      // silent
    } finally {
      commit(types.default.SET_META_ADS_UI_FLAG, { fetchingList: false });
    }
  },

  async connect({ commit, dispatch }, code) {
    commit(types.default.SET_META_ADS_UI_FLAG, { connecting: true });
    try {
      await metaAdsAPI.connect(code);
      await dispatch('get');
    } finally {
      commit(types.default.SET_META_ADS_UI_FLAG, { connecting: false });
    }
  },

  async delete({ commit }, id) {
    commit(types.default.SET_META_ADS_UI_FLAG, { deletingItem: true });
    try {
      await metaAdsAPI.delete(id);
      commit(types.default.DELETE_META_ADS_CONNECTION, id);
    } finally {
      commit(types.default.SET_META_ADS_UI_FLAG, { deletingItem: false });
    }
  },
};

export const mutations = {
  [types.default.SET_META_ADS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_META_ADS_CONNECTIONS]: MutationHelpers.set,
  [types.default.DELETE_META_ADS_CONNECTION]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
